export { default as Pagination, Item as PaginationItem } from './pagination'
export type { Props as PaginationProps } from './pagination'
